import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { ConfirmationButton } from '../../common/components/formControls';
import { faEye, faPenToSquare } from '@fortawesome/free-regular-svg-icons';

const List = ({ termId, isReadonly, t, onDelete, ...rest }) => {
	const columns = [];
	
	if (!termId || termId == 0) {
		columns.push({
			header: t('TermHolidayPeriod_Name'),
				accessor: 'term.name',
					sortable: true
		},
		{
			// empty when the term is not tied to a single centre
			header: t('Common_Center'),
			accessor: 'centerName',
			sortable: true
		})
	}
	columns.push(
		{
			header: t('TermHolidayPeriod_StartDate'),
			accessor: 'startDate',
			cell: (startDate) => (ui.formatDate(startDate)),
			sortable: true
		},
		{
			header: t('TermHolidayPeriod_EndDate'),
			accessor: 'endDate',
			cell: (endDate) => (ui.formatDate(endDate)),
			sortable: true
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => (<div>
				<Link to={termId > 0 ? `/terms/${termId}/termHolidayPeriods/${id}` : `/termHolidayPeriods/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={row.isReadonly ? faEye : faPenToSquare} /> {t(row.isReadonly ? 'Common_View' : 'Common_Edit')}</Link>&nbsp;
				{!row.isReadonly && <ConfirmationButton onConfirmation={() => onDelete(id)} confirmationTitle={t('TermHoliday_DeleteConfirmationTitle')}
					confirmationMessage={t('TermHoliday_DeleteConfirmationMessage')} displayType={'inline'} label={t('Common_Delete')}></ConfirmationButton>}
			</div>)
		})
	

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath={termId > 0 ? `/terms/${termId}/termHolidayPeriods/new` : '/termHolidayPeriods/new'} />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);